export default __webpack_public_path__ + "static/media/bannerPink.73f70715.png";